var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgStarReputation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#6b97a5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.381 0.331)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26,
    height: 26,
    transform: "translate(-0.381 -0.331)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.17,10.4,13.594,5.211a1.068,1.068,0,0,0-2.047,0L9.961,10.4H5.192a1.07,1.07,0,0,0-.622,1.94l3.9,2.787L6.939,20.065a1.071,1.071,0,0,0,1.672,1.168l3.955-3,3.955,3.012a1.071,1.071,0,0,0,1.672-1.168l-1.533-4.941,3.9-2.787a1.069,1.069,0,0,0-.622-1.94H15.17Z",
    transform: "translate(0.296 0.195)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStarReputation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/starReputation.b4e4b9ce.svg";
export { ForwardRef as ReactComponent };